import React, { Component } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { Row, Col } from 'react-bootstrap';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';


const readCookie = require('../cookie.js').readCookie;
const momentRange = require('moment-range');
momentRange.extendMoment(moment);

class Newsletter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ngoList: [],
            completeData: [],
            weeklyData: [],
            year: moment().year().toString(),
            month: moment().month()+1,
            week: '',
            weekOptions: [],
            mailTriggeredOn: '',
            dataGathered: false,
            isOpen: false,
            mailedCount: 0,
            Introduction: EditorState.createWithContent(ContentState.createFromBlockArray(
                convertFromHTML(`Greetings from Mission Swavalamban! <br>
              Here is your weekly performance chart. Kindly refer to this to know about your progress and position over time and in comparison to other SCK partners. We encourage you to visit <a href = "http://letsendorse.net"> SWATI (letsendorse.net)</a> to get a complete picture and take necessary action. Please feel free to reach out to your Program Officer anytime for any queries or guidance. We greatly believe in your community presence and dedication to work on this mission and hope that you shall work towards accomplishing it with hope, hardwork and enthusiasm.`))
            ),
            defIntroduction: EditorState.createWithContent(ContentState.createFromBlockArray(
                convertFromHTML(`Greetings from Mission Swavalamban! <br>
              Here is your weekly performance chart. Kindly refer to this to know about your progress and position over time and in comparison to other SCK partners. We encourage you to visit <a href = "http://letsendorse.net"> SWATI (letsendorse.net)</a> to get a complete picture and take necessary action. Please feel free to reach out to your Program Officer anytime for any queries or guidance. We greatly believe in your community presence and dedication to work on this mission and hope that you shall work towards accomplishing it with hope, hardwork and enthusiasm.`))
            ),
            KeyPoints: EditorState.createWithContent(ContentState.createFromBlockArray(
                convertFromHTML(`<ul><li><b>Mission Swavalamban</b> is an end-to-end enablement model of micro/small business aspirants. We trust your best judgement and wisdom to <b>select only the genuine and serious enterprise aspirants</b> for profile creation and further processing. We highly recommend you to check the following- <u>(i) Knowledge of suppliers and buyers, (ii) Location of business, (iii) Experience and training in the business area</u></li>
                <li>While some aspirants seek bank loans, others seek enablement support (like mentorship, demand-supply linkage, licenses, etc.) to start their enterprises. We are trying to equip the aspirants to get the necessary capital (interest rate range: 8%-15%) on a best effort basis. <b>Kindly do not make any commitments of loans or subsidies to the candidates.</b></li></ul>`)
            )),
            defKeyPoints: EditorState.createWithContent(ContentState.createFromBlockArray(
                convertFromHTML(`<ul><li><b>Mission Swavalamban</b> is an end-to-end enablement model of micro/small business aspirants. We trust your best judgement and wisdom to <b>select only the genuine and serious enterprise aspirants</b> for profile creation and further processing. We highly recommend you to check the following- <u>(i) Knowledge of suppliers and buyers, (ii) Location of business, (iii) Experience and training in the business area</u></li>
                <li>While some aspirants seek bank loans, others seek enablement support (like mentorship, demand-supply linkage, licenses, etc.) to start their enterprises. We are trying to equip the aspirants to get the necessary capital (interest rate range: 8%-15%) on a best effort basis. <b>Kindly do not make any commitments of loans or subsidies to the candidates.</b></li></ul>`)
            )),
            KeyUpdate: EditorState.createEmpty(),
            Spotlight: EditorState.createEmpty(),
            SpotlightImg: '',
            Recommendations: EditorState.createWithContent(ContentState.createFromBlockArray(
                convertFromHTML(`<b>Recommendations for active outreach and promotions:</b></u><br>
              <b>1) ONLINE PROMOTION:</b> Share promotional and awareness-generating content from time to time in WhatsApp groups and Social media networks of the NGO team are a part of. The repository of promotional material can be found here: <a href="http://bit.ly/Promotional-Content">http://bit.ly/Promotional-Content</a><br>
              <b>2) INFLUENCER OUTREACH:</b> Seek help from and create a WhatsApp group of district level influencers like the BDO, PRI members, local authorities, partner NGOs and others and keep sharing progress updates and promotional content for re-circulation.<br>
              <b>3) OFFLINE AWARENESS</b>: Conduct meetings and gatherings of enthusiastic youth and increase awareness about entrepreneurship. You can address trainees of various skill development institutes, organize Sabhas, conduct rallies and distribute our pamphlets.<br>
              <b>4) HUB OF ACTIVITIES:</b> Approach banks, post-offices, Jan Suvidha Kendras, etc. and stick the poster of Mission Swavalamban. These are places of high footfall and would result in great visibility among masses.<br>
              <b>5) MEDIA:</b> If you know of local journalists/reporters, share the success stories of Mission Swavalamban and explore if they can write about the same in local newspapers while promoting your organization's name and the toll-free number. We can help you with the content.`))
            ),
            defRecommendations: EditorState.createWithContent(ContentState.createFromBlockArray(
                convertFromHTML(`<b>Recommendations for active outreach and promotions:</b></u><br>
                <b>1) ONLINE PROMOTION:</b> Share promotional and awareness-generating content from time to time in WhatsApp groups and Social media networks of the NGO team are a part of. The repository of promotional material can be found here: <a href="http://bit.ly/Promotional-Content">http://bit.ly/Promotional-Content</a><br>
                <b>2) INFLUENCER OUTREACH:</b> Seek help from and create a WhatsApp group of district level influencers like the BDO, PRI members, local authorities, partner NGOs and others and keep sharing progress updates and promotional content for re-circulation.<br>
                <b>3) OFFLINE AWARENESS</b>: Conduct meetings and gatherings of enthusiastic youth and increase awareness about entrepreneurship. You can address trainees of various skill development institutes, organize Sabhas, conduct rallies and distribute our pamphlets.<br>
                <b>4) HUB OF ACTIVITIES:</b> Approach banks, post-offices, Jan Suvidha Kendras, etc. and stick the poster of Mission Swavalamban. These are places of high footfall and would result in great visibility among masses.<br>
                <b>5) MEDIA:</b> If you know of local journalists/reporters, share the success stories of Mission Swavalamban and explore if they can write about the same in local newspapers while promoting your organization's name and the toll-free number. We can help you with the content.`))
            )
        }
    }

    async getMailingList() {
        var response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/ngo`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': JSON.parse(readCookie('access_token'))
            }
        })
        var responseData = response.json()
        responseData.then(function (result) {
            if (result.error === false) {
                var filteredData = result.ngos.filter(ele => ele.status === 'Active')
                this.setState({ ngoList: filteredData })
            }
        }.bind(this))
    }

    async getStateDistrict() {
        let ngos = this.state.ngoList;
        let ngo = {};
        const people = _.groupBy(ngos, 'state')

        for (var i = 0; i < Object.keys(people).length; i++) {
            let arr = people[Object.keys(people)[i]];
            ngo[Object.keys(people)[i]] = (_.keys(_.countBy(arr, function (arr) { return arr.district })))
        }

        let Monday = new Date(this.state.week.split("-")[0] + " " + this.state.year)
        Monday = (Monday.getDate() + "-" + (Monday.getMonth() + 1) + "-" + Monday.getFullYear()).toString()
        let Sunday = new Date(this.state.week.split("-")[1] + " " + this.state.year)
        Sunday = (Sunday.getDate() + "-" + (Sunday.getMonth() + 1) + "-" + Sunday.getFullYear()).toString()

        let states = Object.keys(ngo);
        for (let i = 0; i < states.length; i++) {
            // for(var i=0;i<states.length;i++){
            let districts = ngo[states[i]];
            for (var j = 0; j < districts.length; j++) {
                await this.getCompleteData(states[i], districts[j], Sunday);
            }
        }

        let weekly = [];
        for (let i = 0; i < states.length; i++) {
            // for(var i=0;i<states.length;i++){
            let districts = ngo[states[i]];
            for (let j = 0; j < districts.length; j++) {
                // for(var j=0;j<districts.length;j++){
                let response = await this.getWeeklyData(Monday, Sunday, states[i], districts[j]);
                weekly.push(response);
            }
        }
        this.setState({ weeklyData: weekly });
    }

    async getCompleteData(state, district, fetchdate) {
        let start = new Date(2019, 9, 28);
        start = moment("2019-10-28").format("DD-MM-YYYY")

        let params = {
            'state': state,
            'district': district,
            'toDate': fetchdate,
            'fromDate': start
        }
        let returnData = {};
        await fetch(`${process.env.REACT_APP_API_URL}/api/v1/dashboard/top-performers/sck?state=` + state + '&fromDate=' + start + '&toDate=' + fetchdate + '&district=' + district, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': JSON.parse(readCookie('access_token'))
            },
        }).then(response => response.json())
            .then(dt => {
                let data = dt['topScks'];
                if (data[0]) {
                    returnData['ngoName'] = data[0]['ngoName'];
                    returnData['state'] = data[0]['state']
                    returnData['district'] = data[0]['district']
                    returnData['start_date'] = start
                    returnData['end_date'] = fetchdate
                    returnData['callers_assigned'] = data[0]['districtIVRS']
                    returnData['caller_profiles_created'] = data[0]['leads']
                    returnData['pending_caller_profiles'] = returnData['callers_assigned'] - returnData['caller_profiles_created']
                    if (returnData['callers_assigned'] !== 0)
                        returnData['pending_caller_profiles_%'] = (returnData['pending_caller_profiles'] * 100 / returnData['callers_assigned']).toFixed(2);
                    else
                        returnData['pending_caller_profiles_%'] = "NaN"
                    returnData['direct_profiles'] = data[0]['directLeads']
                    returnData['total_profiles'] = data[0]['totalLeads']
                    returnData['total_profiles_not_disqualified'] = data[0]['totalLeadsNotDisqualified']
                    returnData['total_profiles_disqualified'] = returnData['total_profiles'] - returnData['total_profiles_not_disqualified']
                    returnData['percent_disqualified'] = data[0]['disqualificationPercent']
                    this.getLoanFunnelData(params, returnData)
                }
            });
        return returnData;
    }

    async getWeeklyData(start, end, state, district) {
        let returnData = {};

        await fetch(`${process.env.REACT_APP_API_URL}/api/v1/dashboard/top-performers/sck?state=` + state + '&fromDate=' + start + '&toDate=' + end + '&district=' + district, {
            method: "GET",
            headers: {
                'Content-type': 'application/json',
                'x-auth-token': JSON.parse(readCookie('access_token'))
            },
        }).then(response => response.json())
            .then(dt => {
                let data = dt['topScks'];
                if (data[0]) {
                    returnData['ngoName'] = data[0]['ngoName'];
                    returnData['state'] = data[0]['state']
                    returnData['district'] = data[0]['district']
                    returnData['week_start_date'] = start
                    returnData['week_end_date'] = end
                    returnData['callers_assigned'] = data[0]['districtIVRS']
                    returnData['caller_profiles_created'] = data[0]['leads']
                    returnData['direct_profiles'] = data[0]['directLeads']
                    returnData['total_profiles'] = data[0]['totalLeads']
                }
            });
        return returnData;
    }

    async getLoanFunnelData(params, data) {
        var resp = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/dashboard/funnel/loan-funnel-data?state=` + params.state + '&fromDate=' + params.fromDate + '&toDate=' + params.toDate + '&district=' + params.district, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': JSON.parse(readCookie('access_token'))
            },
        })
        var respData = resp.json()
        respData.then(dt => {
            let funnelDict = dt['loanFunnelData']
            if (funnelDict) {
                data['total_loan_applications'] = funnelDict[1].value
                data['total_loan_applications_rejected'] = funnelDict[funnelDict.length - 1].value
                data['total_loans_sanctioned'] = funnelDict[2].value
                data['total_loans_disbursed'] = funnelDict[3].value
            }
            this.getInfographicData(params, data);
        })
    }

    async getInfographicData(params, data) {
        let comp = this.state.completeData;

        fetch(`${process.env.REACT_APP_API_URL}/api/v1/dashboard/infographic-data?state=` + params.state + '&fromDate=' + params.fromDate + '&toDate=' + params.toDate + '&district=' + params.district, {
            method: "GET",
            headers: {
                'Content-type': 'application/json',
                'x-auth-token': JSON.parse(readCookie('access_token'))
            },
        }).then(response => response.json())
            .then(dt => {
                let response = dt['result'];
                if (response) {
                    data['due_diligence_completed'] = response['dueDiligenceStage']['completedCount']
                    data['bplan_completed'] = response['bPlanStage']['completedCount']
                    data['complete_profiles'] = response['profileCreationStage']['completedCount']
                    data['incomplete_profiles'] = response['profileCreationStage']['incompleteCount']
                    if (data['total_profiles'] !== 0)
                        data['incomplete_profiles_%'] = (data['incomplete_profiles'] * 100 / data['total_profiles']).toFixed(2);
                    else
                        data['incomplete_profiles_%'] = "NaN"
                    data['total_enterprises_setup/scaledup'] = response['enterpriseSetupStage']['completedCount']
                }
            })
        comp.push(data);
        this.setState({ completeData: comp });
    }

    getWeeks = (year, month) => {
        let startDate = moment.utc([year, month - 1])
        let firstDay = moment(startDate).startOf('month').day('Monday');
        if (firstDay.date() > 7) firstDay.add(7, 'd')
        let endDay = moment(startDate).endOf('month')
        let monthRange = moment.range(firstDay, endDay);
        let weeks = []
        for (let mday of monthRange.by('days')) {
            if (weeks.indexOf(mday.week()) === -1)
                weeks.push(mday.week());
        }

        let options = [];
        for (let index = 0; index < weeks.length; index++) {
            var weeknumber = weeks[index];
            var firstWeekDay = moment(firstDay).week(weeknumber).day(1);
            if (firstWeekDay.isBefore(firstDay)) {
                firstWeekDay = firstDay;
            }
            var lastWeekDay = moment(endDay).week(weeknumber).day(7);
            if (firstWeekDay < endDay && lastWeekDay > firstDay)
                options.push(firstWeekDay.format("DD MMM") + "-" + lastWeekDay.format("DD MMM"))
        }
        this.setState({ weekOptions: options });
        this.getWeekData(this.state.week);
    }

    onMonthSelect = (e) => {
        let month = parseInt(e.target.value);
        this.setState({ month: month });
        this.getWeeks(this.state.year, month);
        this.setState({ week: "" });
    }

    selectWeek = (e) => {
        let val = e.target.value;
        this.setState({ week: val });
        this.getWeekData(val);
    }

    setYear = (e) => {
        let year = parseInt(e.target.value);
        this.setState({ year: year });
        this.getWeeks(year, this.state.month);
        this.setState({ month: "0" })
        this.setState({ week: "" })
    }

    getWeekData(week) {
        let year = this.state.year;

        fetch(`${process.env.REACT_APP_API_URL}/api/v1/nl/getWeekData?year=` + year + '&week=' + week, {
            method: "GET",
            headers: {
                'Content-type': 'application/json',
                'x-auth-token': JSON.parse(readCookie('access_token'))
            }
        }).then(response => response.json())
            .then(function (data) {
                if (!data.data) {
                    this.setState({ Introduction: this.state.defIntroduction });
                    this.setState({ Recommendations: this.state.defRecommendations });
                    this.setState({ KeyPoints: this.state.defKeyPoints });
                    this.setState({ KeyUpdate: EditorState.createEmpty() });
                    this.setState({ Spotlight: EditorState.createEmpty() });
                    this.setState({ SpotlightImg: '' });
                    this.setState({ mailTriggeredOn: '' });
                }
                if (data.status === "ok") {
                    let info = data.data[0]
                    this.setState({ Introduction: EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(info.introduction).contentBlocks)) });
                    this.setState({ Recommendations: EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(info.recommendations).contentBlocks)) });
                    this.setState({ KeyPoints: EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(info.keyPointsToNote).contentBlocks)) });
                    this.setState({ KeyUpdate: EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(info.keyUpdate).contentBlocks)) });
                    this.setState({ Spotlight: EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(info.spotlightStory).contentBlocks)) });
                    this.setState({ SpotlightImg: info.spotlightImg });
                    this.setState({ mailTriggeredOn: info.triggeredOn });
                }
            }.bind(this))
    }

    onSave = () => {
        fetch(`${process.env.REACT_APP_API_URL}/api/v1/nl/update`, {
            method: "POST",
            headers: {
                'Content-type': 'application/json',
                'x-auth-token': JSON.parse(readCookie('access_token'))
            },
            body: JSON.stringify({
                year: this.state.year,
                month: (this.state.month + 1),
                week: this.state.week,
                introduction: draftToHtml(convertToRaw(this.state.Introduction.getCurrentContent())),
                recommendations: draftToHtml(convertToRaw(this.state.Recommendations.getCurrentContent())),
                keyPointsToNote: draftToHtml(convertToRaw(this.state.KeyPoints.getCurrentContent())),
                keyUpdate: draftToHtml(convertToRaw(this.state.KeyUpdate.getCurrentContent())),
                story: draftToHtml(convertToRaw(this.state.Spotlight.getCurrentContent())),
                spotlightImg: this.state.SpotlightImg,
                triggeredOn: this.state.mailTriggeredOn
            })
        }).then(response => response.json())
            .then(function (res) {
                if (res.status === true) toast.success("Saved Changes");
                else toast.error("Something wrong!");
            })
    }

    onTrigger = async () => {
        this.setState({ isOpen: true });
        if (!this.state.weeklyData[0])
            await this.getStateDistrict();

        if (this.state.weeklyData[0]) {
            let mailedDistricts = [], mailedCount = 0, ratingWeek=[], ratingOverall=[];
            let info = {
                "Introduction": draftToHtml(convertToRaw(this.state.Introduction.getCurrentContent())),
                "KeyPoints": draftToHtml(convertToRaw(this.state.KeyPoints.getCurrentContent())),
                "Recommendations": draftToHtml(convertToRaw(this.state.Recommendations.getCurrentContent())),
                "KeyUpdate": draftToHtml(convertToRaw(this.state.KeyUpdate.getCurrentContent())),
                "Spotlight": draftToHtml(convertToRaw(this.state.Spotlight.getCurrentContent())),
                "SpotlightImg": this.state.SpotlightImg
            }

            let ngoList = this.state.ngoList;
            for (var i = 0; i < ngoList.length; i++) {
                let dis = ngoList[i].district;
                let state = ngoList[i].state;
                let stateRankData = this.getStateRank(dis);
                let missionRankData = this.generateNationalRank(dis);
                let weeklyMetrics = this.getWeeklyMetrics(dis);
                let totalMetrics = this.getTotalMetrics(dis);
                let actionables = this.getActionables(dis);
                let profileStatus = this.getProfileStatus(dis);

                let mailParameters = {};
                mailParameters.district = dis;
                mailParameters.state = state;
                mailParameters.subject = "MISSION SWAVALAMBAN: Weekly status and progress update (" + dis + ")";
                mailParameters.toMailId = ngoList[i].email;
                mailParameters.info = info;
                mailParameters.stateRankData = stateRankData;
                mailParameters.missionRankData = missionRankData;
                mailParameters.weeklyMetrics = weeklyMetrics;
                mailParameters.totalMetrics = totalMetrics;
                mailParameters.actionables = actionables;
                mailParameters.profStatus = profileStatus;
                // mailParameters.week_rating = weeklyMetrics.profiles_created > 50 ? "Good" : "Poor"
                // mailParameters.total_rating = totalMetrics.profiles_created > 700 ? "Good" : "Poor"
                mailParameters.week_rating = weeklyMetrics.total_profiles > 50 ? "Good" : "Needs Improvement";
                mailParameters.total_rating = totalMetrics.total_profiles > 700 ? "Good" : "Needs Improvement";
                ratingWeek.push(weeklyMetrics.total_profiles);
                ratingOverall.push(totalMetrics.total_profiles);
                var response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/nl/sendMail`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'x-auth-token': JSON.parse(readCookie('access_token'))
                    },
                    body: JSON.stringify(mailParameters)
                })
                var respData = response.json()
                // eslint-disable-next-line no-loop-func
                respData.then(function (res) {
                    if (res.status === true) {
                        mailedCount += 1;
                        this.setState({ mailedCount: mailedCount });
                        mailedDistricts.push(dis);
                        if (mailedCount === ngoList.length) {
                            let triggered = moment().format("DD-MMM-YYYY");
                            this.setState({ mailTriggeredOn: triggered });
                            this.onSave();
                        }
                    }
                }.bind(this))
            }
        }
    }
    // sum(numbers) {
    //     return numbers.reduce((totalValue, currentValue) => totalValue + currentValue, 0);
    // }

    getProfileStatus(district) {
        let totalData = this.state.completeData
        let total = totalData.find(t => t.district === district);
        let profStatus = {};
        profStatus['dd_completed'] = total['due_diligence_completed']
        profStatus['bplan_completed'] = total['bplan_completed']
        profStatus['loan_applications'] = total['total_loan_applications']
        profStatus['loan_app_rej'] = total['total_loan_applications_rejected']
        profStatus['loans_sanctioned'] = total['total_loans_sanctioned']
        profStatus['loans_disbursed'] = total['total_loans_disbursed']
        profStatus['enterprises_setup_or_scaled'] = total['total_enterprises_setup/scaledup']
        return profStatus
    }

    getActionables(district) {
        let totalData = this.state.completeData
        let total = totalData.find(t => t.district === district);
        let actionables = {};
        actionables['pending_profile_creation'] = total['pending_caller_profiles']
        actionables['pending_caller_profiles_percent'] = total['pending_caller_profiles_%']
        actionables['incomplete_profiles'] = total['incomplete_profiles']
        actionables['incomplete_profiles_percent'] = total['incomplete_profiles_%']
        return actionables
    }


    getStateRank(district) {
        let total = this.state.completeData;
        let disData = total.find(t => t.district === district)
        let filter = total.filter(t => t.state === disData.state);

        let sortCreated = _.orderBy(filter, ['total_profiles'], ['desc']);
        let sortCompleted = _.orderBy(filter, ['complete_profiles'], ['desc']);
        let create_rank = sortCreated.findIndex(function (item, i) {
            return item.district === district;
        })
        disData['complete_rank_profile_creation'] = create_rank + 1;

        let comp_rank = sortCompleted.findIndex(function (item, i) {
            return item.district === district;
        })
        disData['complete_rank_profile_completion'] = comp_rank + 1;

        let stateRankData = {};
        stateRankData['district_rank_data'] = {
            'ngoName': disData['ngoName'],
            'profile_creation_rank': disData['complete_rank_profile_creation'],
            'profiles_created': disData['total_profiles'],
            'profile_completion_rank': disData['complete_rank_profile_completion'],
            'profiles_completed': disData['complete_profiles']
        }

        stateRankData['top_sck_rank_data'] = {
            'ngoName_creation': sortCreated[0]['ngoName'],
            'profile_creation_rank': 1,
            'profiles_created': sortCreated[0]['total_profiles'],
            'ngoName_completion': sortCompleted[0]['ngoName'],
            'profile_completion_rank': 1,
            'profiles_completed': sortCompleted[0]['complete_profiles']
        }
        return stateRankData;
    }

    generateNationalRank(district) {
        let total = this.state.completeData;
        let disData = total.find(t => t.district === district)

        let sortCreate = _.orderBy(total, ['total_profiles'], ['desc']);
        let sortComplete = _.orderBy(total, ['complete_profiles'], ['desc']);

        let create_rank = sortCreate.findIndex(function (item, i) {
            return item.district === district;
        })
        disData['complete_rank_profile_creation'] = (create_rank + 1);
        let comp_rank = sortComplete.findIndex(function (item, i) {
            return item.district === district
        })
        disData['complete_rank_profile_completion'] = (comp_rank + 1);

        let missionRankData = {};
        missionRankData['district_rank_data'] = {
            'ngoName': disData['ngoName'],
            'profile_creation_rank': disData['complete_rank_profile_creation'],
            'profiles_created': disData['total_profiles'],
            'profile_completion_rank': disData['complete_rank_profile_completion'],
            'profiles_completed': disData['complete_profiles']
        }

        missionRankData['top_sck_rank_data'] = {
            'ngoName_creation': sortCreate[0]['ngoName'],
            'profile_creation_rank': 1,
            'profiles_created': sortCreate[0]['total_profiles'],
            'ngoName_completion': sortComplete[0]['ngoName'],
            'profile_completion_rank': 1,
            'profiles_completed': sortComplete[0]['complete_profiles']
        }
        return missionRankData;
    }

    getTotalMetrics = (district) => {
        let totalData = this.state.completeData;
        let total = totalData.find(t => t.district === district);
        total['till_date'] = total['end_date']
        delete total['end_date'];
        return total;
    }

    getWeeklyMetrics = (district) => {
        let weekData = this.state.weeklyData;
        let week = weekData.filter(function (ele) { return ele.district === district })[0];
        week['week'] = week['week_start_date'] + " to " + week['week_end_date'];
        return week;
    }

    async componentDidMount() {
        if (this.state.year && this.state.month) {
            this.getWeeks(this.state.year, this.state.month);
        }
        await this.getMailingList();
    }

    render() {
        const allYears = [];
        for (let i = 2020; i <= moment().year(); i++){
            allYears.push(i);
        }
        return (
            <div className={this.props.userData ? "page-container nl-page" : "nl-page"}>
                <div className="page-heading d-flex">
                    <h3>Communication</h3>
                </div>

                <div className="filters">
                    <label className="control-label">{'Year: '}</label>
                    <select className="selectfield" name="Selectyear" id="yearselect" value={!this.state.year ? '2020' : this.state.year} onChange={this.setYear}>
                        <option value="default">Select year</option>
                        {/* <option value="2020">2020 </option>
                        <option value="2021">2021</option>
                        <option value="2022">2022</option> */}
                        {
                            allYears.map((year,ind) => {
                                return <option key={ind} value={year.toString()}>{ year}</option>;
                            })
                        }
                    </select>

                    <label className="control-label">{'Month: '}</label>
                    <select className="selectfield" name="Selectmonth" id="monthselect" value={!this.state.month ? '0' : this.state.month} onChange={this.onMonthSelect}>
                        <option value="0" >Select month</option>
                        <option value="1">January</option>
                        <option value="2"> February</option>
                        <option value="3"> March</option>
                        <option value="4"> April</option>
                        <option value="5"> May</option>
                        <option value="6"> June</option>
                        <option value="7"> July</option>
                        <option value="8"> August</option>
                        <option value="9"> September</option>
                        <option value="10"> October</option>
                        <option value="11"> November</option>
                        <option value="12"> December</option>
                    </select>

                    <label className="control-label">{'Week: '}</label>
                    <select className="selectfield" name="Selectweek" id="weekselect" value={this.state.week ? this.state.week : ''} onChange={this.selectWeek} options={this.state.weekOptions}>
                        <option value="" selected>Select Week </option>
                        {this.state.weekOptions.map(function (week, index) {
                            return (
                                <option value={week} key={index}>{week}</option>
                            )
                        })}
                    </select>
                </div>
                <div>
                    <Row className="inputdiv">
                        <Col md="3">
                            <label className="label"> Introduction </label>
                        </Col>
                        <Col>
                            <Editor editorClassName="textArea" editorState={this.state.Introduction} onEditorStateChange={(editorState) => { this.setState({ Introduction: editorState, }) }}
                                toolbar={{ options: ['inline', 'list', 'fontSize', 'blockType', 'colorPicker', 'link', 'embedded', 'emoji', 'remove'] }} />
                        </Col>
                    </Row>
                    <Row className="inputdiv">
                        <Col md="3">
                            <label className="label">Weekly & Overall Performance </label>
                        </Col>
                        <Col> <span>: AUTO GENERATED </span> </Col>
                    </Row>
                    <Row className="inputdiv">
                        <Col md="3">
                            <label className="label"> Recommendations </label></Col>
                        <Col>
                            <Editor editorClassName="textArea" editorState={this.state.Recommendations} onEditorStateChange={(editorState) => { this.setState({ Recommendations: editorState, }) }}
                                toolbar={{ options: ['inline', 'list', 'fontSize', 'blockType', 'colorPicker', 'link', 'embedded', 'emoji', 'remove'] }} />
                        </Col>
                    </Row>
                    <Row className="inputdiv">
                        <Col md="3">
                            <label className="label">Action Pending on SCK </label>
                        </Col>
                        <Col> <span> : AUTO GENERATED </span>  </Col>
                    </Row>
                    <Row className="inputdiv">
                        <Col md="3">
                            <label className="label">Performance Ranking of SCK  </label>
                        </Col>
                        <Col> <span> : AUTO GENERATED </span>  </Col>
                    </Row>
                    <Row className="inputdiv">
                        <Col md="3">
                            <label className="label">Status of Profiled Candidates  </label>
                        </Col>
                        <Col> <span> : AUTO GENERATED </span> </Col>
                    </Row>
                    <Row className="inputdiv">
                        <Col md="3">
                            <label className="label">Key points to note </label>
                        </Col>
                        <Col>
                            <Editor editorClassName="textArea" editorState={this.state.KeyPoints} onEditorStateChange={(editorState) => { this.setState({ KeyPoints: editorState }) }}
                                toolbar={{ options: ['inline', 'list', 'fontSize', 'blockType', 'colorPicker', 'link', 'embedded', 'emoji', 'remove'] }} />
                        </Col>
                    </Row>
                    <Row className="inputdiv">
                        <Col md="3">
                            <label className="label">Key Updates</label>
                        </Col>
                        <Col>
                            <Editor editorClassName="textArea" editorState={this.state.KeyUpdate} onEditorStateChange={(editorState) => { this.setState({ KeyUpdate: editorState, }) }}
                                toolbar={{ options: ['inline', 'list', 'fontSize', 'blockType', 'colorPicker', 'link', 'embedded', 'emoji', 'remove'] }} />
                        </Col>
                    </Row>
                    <Row className="inputdiv">
                        <Col>
                            <label className="label">Swavalambi  Spotlight </label>
                        </Col>
                    </Row>
                    <Row className="inputdiv">
                        <Col md="3">
                            <label className="label">Image URL</label>
                        </Col>
                        <Col>
                            <textarea value={this.state.SpotlightImg} name='SpotlightImg' onChange={(e) => { this.setState({ 'SpotlightImg': e.target.value }) }} className="inputfield" rows="2"></textarea>
                        </Col>
                    </Row>
                    <Row className="inputdiv">
                        <Col md="3">
                            <label className="label">Swavalambi Story</label>
                        </Col>
                        <Col>
                            <Editor editorClassName="textArea" editorState={this.state.Spotlight} onEditorStateChange={(editorState) => { this.setState({ Spotlight: editorState, }) }}
                                toolbar={{ options: ['inline', 'list', 'fontSize', 'blockType', 'colorPicker', 'link', 'embedded', 'emoji', 'remove'] }} />
                        </Col>
                    </Row>
                </div>

                {this.state.isOpen ? (
                    <div className="triggerInfo">
                        {this.state.weeklyData[0] ?
                            ("Triggered successfully for " + this.state.mailedCount + " district NGOs") : ("Gathering data...")}
                    </div>
                ) : (null)}

                {this.state.mailTriggeredOn === '' ? (
                    this.state.week && this.state.week !=='' ?
                    <div className="buttonDiv">
                        <button className="le-button" onClick={this.onSave}>SAVE CHANGES</button>
                            <button title={new Date(this.state.week.split("-")[0] + " " + this.state.year) > new Date() ? 'Can\'t trigger mails for future dates' : "Click to trigger emails now!"} className={new Date(this.state.week.split("-")[0] + " " + this.state.year) > new Date() ? "le-button-disabled ml10" : "le-button ml10"} disabled={new Date(this.state.week.split("-")[0] + " " + this.state.year) > new Date()} onClick={this.onTrigger}>TRIGGER EMAILS NOW</button>
                        </div> :
                        (<div className="buttonDiv">
                            <button className="le-button-disabled" disabled title="Please select a week to save changes">SAVE CHANGES</button>
                            <button className="le-button-disabled ml10" disabled title="Please select a week to trigger email">TRIGGER EMAILS NOW</button>
                        </div>)
                ) :
                    (<div className="buttonDiv">
                        <button className="le-button-disabled" disabled>SAVE CHANGES</button>
                        <button className="le-button-disabled ml10" disabled>Triggered On {this.state.mailTriggeredOn}</button>
                    </div>)}
            </div>
        );
    }
}

export default Newsletter;